// extracted by mini-css-extract-plugin
module.exports = {"buttonBox":"ImageTextCard_buttonBox__GAyDW","assetContainer":"ImageTextCard_assetContainer___r99Q","image":"ImageTextCard_image__Jzx5m"};